<template>
    <div class="custom-container">Willkommen!</div>
</template>

<script>
    export default {
        name: "home-content"
    }
</script>

<style scoped>

</style>